import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { header } from "./drawer.module.scss";

const Header = ({ className, ...props }) => (
  <header className={classNames(header, "p-4", className)} {...props} />
);

Header.propTypes = {
  className: PropTypes.string
};

Header.defaultProps = {
  className: ""
};

export default Header;
